import React from 'react'
import { useAuth } from 'react-oidc-context'

import { useMediaQueryContext } from '../../contexts/MediaQueryContext'
import ScrollToTop from '../Navigation/ScrollToTop'

interface ICardContainerProps {
  children: React.ReactNode | React.ReactNode[]
  className?: string
  containerClassName?: string
  title?: React.ReactNode | React.ReactNode[]
  disableScrollToTop?: boolean
  dataTestId?: string
}

const CardContainer: React.FC<ICardContainerProps> = ({
  children,
  className = '',
  containerClassName = '',
  title,
  disableScrollToTop = false,
  dataTestId = '',
}) => {
  const { isAuthenticated } = useAuth()
  const { isMd } = useMediaQueryContext()

  return (
    <>
      <div
        className={`tc-mv-main-wrapper ${
          isAuthenticated ? '' : 'no-auth'
        } pb-24 ${containerClassName}`}
      >
        <div className="tc-mv-card-wrapper">
          {title}
          <div
            data-testid={dataTestId}
            className={`tc-mv-card-container tc-mv-card-container-home ${className}`}
          >
            {children}
          </div>
        </div>
      </div>
      {!disableScrollToTop && !isMd && <ScrollToTop />}
    </>
  )
}

export { CardContainer }
